import ContactForm from "../../components/ContactForm";
import Section from "../../components/Section";
import SectionLayout from "../../components/[przyjaznedeklaracje]/_sectionLayout";

import DeclarationBox from "../../components/DeclarationBox";
import DeclarationBoxItem from "../../components/DeclarationBoxItem";
import DeclarationModal from "../../components/DeclarationModal";

import SectionBox from "../../components/SectionBox";
import BackgroundSection from "../../components/BackgroundSection";

import Variables from "../../variables/variables.json";

import DlaSamorzaduSection1PL from "../../content/przyjaznedeklaracje/dla-samorzadu/section-1_pl.mdx";
import DlaSamorzaduSection2PL from "../../content/przyjaznedeklaracje/dla-samorzadu/section-2_pl.mdx";
import Testimonial from "../../components/Testimonial";

export default function DlaSamorzadu(props) {
	let Miasto = "PRZYJAZNEDEKLARACJE";
	let Podatek = "dlasamorzadu";

	return (
		<SectionLayout miasto={Miasto} podatek={Podatek} typeHero="carousel" breadcrumbsLayout="dark">
			<Section mdx lightdark id="wypelnij-deklaracje">
				<DlaSamorzaduSection1PL />
			</Section>

			<Section title="sections.obslugiwanepodatki.title">
				<SectionBox light round section="obslugiwanepodatki" />
			</Section>

			<Section mdx lightdark>
				<DlaSamorzaduSection2PL />
			</Section>

			<Section title="sections.proceswdrozenia.title">
				<SectionBox light section="proceswdrozenia" box />
			</Section>

			<BackgroundSection
				miasto={Miasto}
				section="wersjademo"
				attachment
				textAlign="left"
				button="primary"
				title
				subtitle
				bgColor="shadow"
			/>

			<Section title="sections.opiniesamorzadowcow.title">
				<Testimonial miasto={Miasto} />
			</Section>
		</SectionLayout>
	);
}
